
import { getMyCard, addExchange, addAnswer, checkExchange } from '@/api/chunjie'
import { nowInDateBetwen } from '@/libs/utils'
import Toast from 'vux/src/components/toast/index.vue'
import cookie from 'vux/src/tools/cookie/index.js'
import Countdown from 'vux/src/components/countdown/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { getview } from '@/api/jfhl.js'
import pic1 from '../../assets/chunjie/fokas/pic1.png'
import pic2 from '../../assets/chunjie/fokas/pic2.png'
import pic3 from '../../assets/chunjie/fokas/pic3.png'
import pic4 from '../../assets/chunjie/fokas/pic4.png'
import pic5 from '../../assets/chunjie/fokas/pic5.png'
import pic6 from '../../assets/chunjie/fokas/pic6.png'
import pic7 from '../../assets/chunjie/fokas/pic7.png'
import pic8 from '../../assets/chunjie/fokas/pic8.png'
import pic9 from '../../assets/chunjie/fokas/pic9.png'
import pic10 from '../../assets/chunjie/fokas/pic10.png'
import pic11 from '../../assets/chunjie/fokas/pic11.png'
import pic12 from '../../assets/chunjie/fokas/pic12.png'
export default {
directives: {
TransferDom
},
components: {
XDialog,
Countdown,
Toast
},
name: '',
data () {
return {
fkObj: [],
viewdata: '',
viewdata2: '',
partyid: '1385',
partyid2: '1386',
paperInfoid: '',
lotid: '',

mobile: '',
randnum: '',
fudai: false,
fudaistatus: 0,
dati: false,
total: 0,
show: false,
showtoast: false,
countdown: {
time: 45,
value: '发送',
start: false
},
exchangeObj: {},
check_list: [],
cards: [],
paperid: ''
}
},
created () {
this.view()
},
watch: {
},
computed: {
userid () {
return this.$store.state.user.userid
},
accountid () {
return this.$store.state.user.accountid
}
},
methods: {

view () {
getview({
id: this.partyid
}).then(res => {
this.viewdata = res.obj
getview({
id: this.partyid2
}).then(res => {
this.viewdata2 = res.obj
this.paperid = res.obj.paperid
this.getfokas(this.checkExchangeNow)
})
})
},
choose (item, i) {
console.log('fk', this.fkObj)
if (item.active) {
item.active = false
} else {
if (this.check_list.length < 3) {
item.active = true
}
}
this.check_list = []
this.cards = []
this.fkObj.forEach(res => {
if (res.active == true) {
this.check_list.push(res.pic)
this.cards.push(res.carid)
}
})
console.log(this.cards)
},
getfokas (fn) {
this.fkObj = [
{ pic: pic1, num: 0 },
{ pic: pic2, num: 0 },
{ pic: pic3, num: 0 },
{ pic: pic4, num: 0 },
{ pic: pic5, num: 0 },
{ pic: pic6, num: 0 },
{ pic: pic7, num: 0 },
{ pic: pic8, num: 0 },
{ pic: pic9, num: 0 },
{ pic: pic10, num: 0 },
{ pic: pic11, num: 0 },
{ pic: pic12, num: 0 }
]
this.total = 0
this.fudai = false
getMyCard({
openid: this.accountid,
partyid: this.partyid
}).then(data => {
this.fudaistatus = nowInDateBetwen(

this.viewdata.signstartdate,
this.viewdata.signenddate
)
this.dati = nowInDateBetwen(

this.viewdata2.signstartdate,
this.viewdata2.signenddate
)
data.returnValue.forEach(item => {
this.total++
let n = this.fkObj[item.type - 1].num
this.$set(this.fkObj[item.type - 1], 'num', n + 1)
this.$set(this.fkObj[item.type - 1], 'active', false)
this.$set(this.fkObj[item.type - 1], 'name', item.typename)
this.$set(this.fkObj[item.type - 1], 'carid', item.carid)
})
for (let i = 0; i < 12; i++) {
if (this.fkObj[i].num === 0) {
if (fn) fn()
return
} else if (i === 11) {
this.fudai = true
}
}
if (fn) fn()
}
)
},

exchange () {
addExchange({
openid: this.accountid,
partyid: this.partyid,
mobile: this.mobile,
randnum: this.randnum
}).then(data => {
let that = this
this.show = false
this.$vux.alert.show({
content: '成功兑换福袋：' + data,
onHide () {
that.getfokas()
that.checkExchangeNow()
}
})
}
)
},
addAnswerNums () {
if (this.check_list.length < 3) {
this.$vux.toast.text('请选择三张不同的福卡！')
return false
} else {
addAnswer({
openid: this.accountid,
partyid: this.partyid,
baseid: this.paperid,
cards: this.cards.join(',')
}).then(data => {
var that = this
this.$vux.alert.show({
content: '成功兑换一次灯谜答题机会',
buttonText: '去猜灯谜',
onHide () {
that.$router.push({ name: 'page_index' })
}
})
})
}
},
checkExchangeNow () {
checkExchange({
openid: this.accountid,
partyid: this.partyid
}).then(data => {
this.exchangeObj = data.returnValue
if (
this.fudaistatus === 1 &&
this.fudai &&
this.exchangeObj.status === 0
) {
this.showtoast = true
} else {
this.showtoast = false
}
})
},
viewmyfokas () {
this.$vux.alert.show({
content: '已兑换福袋：' + this.exchangeObj.lvName
})
}
}
}
